import React, { useState } from 'react';
import { GECKO_CONSTS, GeckoField } from '../../ui';
import OptionalRequiredFieldsDropdown from '../OptionalRequiredFieldsDropdown';
import './index.scss';

export const PreChatFormFieldSelector = (props) => {
  //Value list can be an array of string keys (unique) or objects (key, label, isRequired)
  const transformOldFormat = (valueList = []) =>
    valueList.map((value) => {
      if (value.key) {
        return value;
      }
      const field = props.customFields.find((field) => field.key === value);
      return { key: field.key, required: true, label: field.label };
    });

  const values = transformOldFormat(props.value);

  const removeValue = (removedValue) => {
    props.onChange(values.filter((value) => value.key !== removedValue.key));
  };

  const updateRequired = (key) => (required) => {
    const value = values.find((value) => value.key === key);
    value.required = required;
    props.onChange(values);
  };

  const renderValues = (values) => {
    return (
      <div className="PreChatFormFieldSelector-select-value">
        {values.map(renderValue)}
      </div>
    );
  };

  const renderValue = (value) => {
    if (!value) return;
    return (
      <OptionalRequiredFieldsDropdown
        key={`OptionalRequiredFieldsDropdown-${value.key}`}
        fieldName={value.label}
        isRequired={value.required}
        updateRequiredStatus={updateRequired(value.key)}
        canRemoveField={true}
        removeField={() => removeValue(value)}
      />
    );
  };

  const filterOutSelectedValues = (field) =>
    values.find((value) => value.key === field.key) === undefined;

  const field = {
    key: 'value',
    type: GECKO_CONSTS.FIELD_TYPE_SELECT_MULTI,
    options: (props.customFields || [])
      // Remove selected ones as value equivalence doesn't work on objects in select
      .filter(filterOutSelectedValues)
      .map((field) => ({
        label: field.label,
        value: { key: field.key, required: true, label: field.label },
      })),
    config: {
      ...props.selectProps,
    },
    placeholder: 'Select Form Fields',
  };

  const handleChange = (_key, value) => {
    props.onChange([...values, ...value]);
  };

  return (
    <div className={'PreChatFormFieldSelector'}>
      <GeckoField field={field} values={values} handler={handleChange} />
      <div>
        <span>Selected Fields</span>
        {renderValues(values)}
      </div>
    </div>
  );
};

export default PreChatFormFieldSelector;
